var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"pl-1"},[(_vm.hasValidNumber)?_c('BTag',{attrs:{"rounded":"","type":_vm.type,"data-cy-tag":"notification-count"}},[_vm._v(_vm._s(_vm.isCountGreaterThan99 ? '99+' : _vm.count))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }